<script setup lang="ts">
import type { TripSummarySegment } from '../../models';

interface TripPriceSummaryProps {
  priceSegments: TripSummarySegment[];
}

const props = defineProps<TripPriceSummaryProps>();
</script>

<template>
  <div class="trip-price-summary">
    <div v-if="props.priceSegments.length" class="price-segments">
      <div
        v-for="(priceSegment, index) in props.priceSegments"
        :key="index"
        class="price-segment"
      >
        <div class="segment-title">
          {{ priceSegment.title }}
        </div>
        <div
          v-for="(price, priceIndex) of priceSegment.price"
          :key="priceIndex + price.description + price.value"
          class="segment-price"
        >
          <div class="segment-price-label">{{ price.description }}</div>
          <div class="segment-price-value">
            {{ price.value }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-products">-</div>
  </div>
</template>

<style scoped lang="scss">
.trip-price-summary {
  .price-segments {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    .price-segment {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      gap: var(--spacing-8);
      @include font-label-l-light;
      color: var(--color-neutral-70);

      .segment-title {
        @include font-label-l-bold;
      }

      .segment-price {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: var(--spacing-8);

        .segment-price-label {
          line-height: var(--line-heights-18);
        }

        .segment-price-value {
          color: var(--color-neutral-70);
        }
      }

      &:not(:last-child) {
        border-bottom: 1px solid var(--color-neutral-30);
        padding-bottom: var(--spacing-16);
        margin-bottom: var(--spacing-16);
      }

      &:last-child {
        padding-bottom: var(--spacing-16);
      }
    }
  }

  .no-products {
    @include font-label-l-light;
    color: var(--color-neutral-70);
  }
}
</style>
